import { createContext } from 'react';

const initialContext: any = {
  currentSlide: {},
  updateCurrentSlide: () => {},
  goToNextSlide: () => {},
  goToPreviousSlide: () => {},
  slides: [],
  sandboxSlides: [],
  // updateSlides: () => {},
  updateSelectedOption: () => {},
  getSlideIndex: () => {},
  showInitialPopup: true,
  setShowInitialPopup: () => {},
  urlParams: '',
  setUrlParams: () => {},
  savedEmail: '',
  setSavedEmail: () => {},
  phoneUpdated: '',
  setPhoneUpdated: () => {},
  geoData: {},
  setGeoData: () => {},
  changedState: false,
  setChangedState: () => {},
  deBrandedDomain: {},
  loadedHome: false,
  setLoadedHome: () => {},
  loadedInitialScripts: false,
  setLoadedInitialScripts: () => {},
  slfApiUrl: '',
  usedPanelOnTheRoofFailsafe: false,
  setUsedPanelOnTheRoofFailsafe: () => {},
  startedFunnel: false,
  setStartedFunnel: () => {},
  referralData: {},
  setReferralData: () => {},
};

const AppContext = createContext(initialContext);

export default AppContext;
